import styled from 'styled-components';
import colors from '../../assets/colors';

export const Wrapper = styled.div`
  flex: 1;
  height: 100vh;
  background-color: #f6f6f6;
  
  @media (min-width: 768px) {
    display: flex;
  }
`;

export const BackgroundContent = styled.div`
  @media (max-width: 767px) {
    background-image: none !important;
  }

  @media (min-width: 768px) {
    flex: 1;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: right;
  }
`;

export const Logo = styled.img`
  width: 60px;
  height: 60px;
  padding: 20px 15px 15px;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  user-select: none;

  @media (min-width: 768px) {
    width: 60px;
    height: 60px;
    padding: 30px;
    float: right;
  }
`;

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const Register = styled.div`
  display: flex;
  height: 80px;
  margin: 0 15px 20px 15px;
  align-items: center;

  p {
    font-size: 0.9rem;
    padding: 10px 20px 14px 0;
  }

  button {
    cursor: pointer;
    padding: 0 20px;
    margin-bottom: 4px;
    height: 40px;
    background: linear-gradient(180deg, rgba(55,205,63,1) 0%, rgba(41,157,44,1) 100%);
    border: none;
    border-radius: 100px;
    white-space: nowrap;
    text-transform: uppercase;
    font-size: 14px;
    font-weight: 600;
    color: ${colors.white};
    font-family: 'Open Sans', sans-serif;
    outline: none;
  }

  button:hover { opacity: .9 }

  @media (min-width: 768px) {
    display: flex;
    align-items: flex-end;
    align-self: flex-end;
    height: 90px;
    margin-right: 50px;
  }
`;

export const Content = styled.div`
  padding: 0 15px 30px;
  
  div.login {
    div.welcome {
      margin-bottom: 30px;

      h1 {
        font-size: 1.3rem;
        color: ${colors.primary};
        margin: 0 0 5px;
      }

      p {
        font-size: 0.9rem;
        margin: 0;
      }
    }
  }

  @media (min-width: 768px) {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 50px 50px 140px;

    div.login {
      width: 450px;
    }
  }
`;

export const Label = styled.div`
  display: flex;
  margin-bottom: 15px;
  background-color: ${colors.white};
  box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
  border-radius: 10px;
  border: ${(props) => {
    if (props.error) return `1px solid ${colors.red}`;
    if (props.onFocusInput) return `1px solid ${colors.primary}`;
    return `1px solid ${colors.white}`;
  }};

  .fa-lock { font-size: 1.15rem; margin: 13px 2px 13px 15px !important }

  .fa {
    margin: 14px 2px 14px 15px;
    color: ${(props) => {
    if (props.error) return `${colors.red}`;
    if (props.onFocusInput) return `${colors.primary}`;
    return `${colors.light}`;
  }};


  }
`;

export const Form = styled.form` 
  display: flex;
  flex-direction: column;
`;

export const Input = styled.input`
  width: 100%;
  background-color: transparent;
  border: none;
  padding: 12px;
  outline: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
`;

export const Link = styled.a`
  font-size: 14px;
  text-decoration: underline;
  color: ${colors.primary};
  margin: 12px 15px 11px 0;
  cursor: pointer;
  
  :hover { opacity: .9 }
`;

export const Button = styled.button`
  cursor: pointer;
  margin-top: 15px;
  padding: 15px 0 14px;
  background: ${colors.primary};
  background: linear-gradient(180deg, rgba(55,205,63,1) 0%, rgba(41,157,44,1) 100%);
  border: none;
  border-radius: 100px;
  text-transform: uppercase;
  font-size: 0.9rem;
  font-weight: 600;
  color: ${colors.white};
  font-family: 'Open Sans', sans-serif;
  outline: none;
  
  :hover { opacity: .9 }
`;
